"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _contactEnrichment = require("./contactEnrichment.types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  /**
   * Status of enrichment.
   *
   * @type {'initial' | 'research-processing' | 'research-failed' | 'pending' |  'fulfilled'} -
   * initial - when  enrichment not rendered or started.
   * awaiting - when apollo researching enrichment profiles.
   * failed - when apollo research fails.
   * processed - when apollo successfully complete research.
   * rejected - when request completed with unexpected error.
   */
  status: 'initial',

  /**
   * Id of contact enrichment.
   *
   * @type {number|null}
   */
  id: null
};
exports.initialState = initialState;

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _contactEnrichment.CONTACT_ENRICHMENT.RESEARCH:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        status: 'awaiting',
        id: action.payload
      });

    case _contactEnrichment.CONTACT_ENRICHMENT.CANCEL:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        status: 'initial'
      });

    case _contactEnrichment.CONTACT_ENRICHMENT.COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: action.payload.status
      });

    case _contactEnrichment.CONTACT_ENRICHMENT.FAILED:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        status: 'rejected'
      });

    default:
      return state;
  }
};

exports.reducer = reducer;